import React from 'react';
import { Navigate } from 'react-router-dom';

import { usePermissions } from './usePermissions';

const PermissionGuard = ({
  permission,
  permissions,

  permissionMode = 'all',

  fallback = null,
  redirectTo,

  children,
}) => {
  const { isReady, can, canAny, canAll } = usePermissions();

  if (!isReady) {
    return null;
  }

  let allowed = true;

  if (permission) {
    allowed = can(permission);
  }

  if (permissions?.length) {
    const listAllowed =
      permissionMode === 'any' ? canAny(permissions) : canAll(permissions);
    allowed = allowed && listAllowed;
  }

  if (allowed) {
    return children;
  }

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return fallback;
};

export default PermissionGuard;
